import useSWR, { SWRResponse } from "swr";
import { IUseCustomerInfoLoggedInUser } from "./types";
import commonSwrConfig from "@portal/hooks/commonSwrConfig";
import { ICustomerInfo } from "@portal/types/api/ICustomerInfo";
import { useSession } from "@portal/auth/client/SessionProvider";

const useCustomerInfoLoggedInUser: IUseCustomerInfoLoggedInUser = () => {
  const { update } = useSession();

  const path = "/api/customerInfo/loggedInUser";

  const fetcher = async (url: URL): Promise<ICustomerInfo> => {
    const response = await fetch(url, {
      method: "GET",
      headers: [["accepts", "application/json"]],
    });

    if (response.status !== 200) {
      throw response.status;
    }

    return await response.json();
  };

  const { data, error, isLoading }: SWRResponse<ICustomerInfo, unknown> = useSWR(path, fetcher, commonSwrConfig(update));
  const response = { data, error, isLoading };

  return response;
};

export default useCustomerInfoLoggedInUser;
